import { ErrorMessage, Form, Formik } from "formik";
import React, { useState } from "react";

import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";
import Label from "./Label";
import Field from "./Field";
import ActionButton from "./ActionButton";
import { CommonService } from "../store/common/CommonSlice";
import { useDispatch } from "react-redux";
import Toaster from "./Toaster";
import { FormValidation } from "../util/Utils";

interface AddSchool {
  schoolNameAdded?: any;
  handleModalClose?: any;
}

export default function Addschool(props: AddSchool) {
  const { schoolNameAdded } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch<any>();
  type initialType = {
    schoolName: string;
  };
  const [loading, setLoading] = useState<boolean>(false);

  const initialValue = {
    schoolName: "",
  };

  const handleSubmit = (values: initialType) => {
    setLoading(true);
    dispatch(CommonService({ apiAction: "AddSchool", schoolName: values }))
      .then((result: any) => {
        if (result?.payload?.status === 200) {
          schoolNameAdded(result.payload, values.schoolName);
          Toaster.success(undefined, result.payload.data.message);
        } else {
          Toaster.error(undefined, result.payload);
        }
      })
      .catch((err: any) => {
        console.log(err); //This console for debug the app if any error occurred in DEV
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return (
    <div className="margin-up-10">
      <Formik
        initialValues={initialValue}
        onSubmit={handleSubmit}
        validationSchema={Yup.object().shape({
          schoolName: Yup.string()
            .required("School Name is required")
            .matches(
              FormValidation.getNamePattern(),
              `${t("schoolName")} ${t("is")} ${t("incorrect")}`
            ),
        })}
      >
        {({
          values,
          handleChange,
          handleBlur,
          errors,
          dirty,
          isValid,
          resetForm,
          touched,
        }: any) => {
          return (
            <Form>
              <Grid container>
                <Label required title={t("schoolName")} />
                <Field
                  className="textFiled"
                  placeholder="Enter Here"
                  name="schoolName"
                  value={values.schoolName}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  helperText={<ErrorMessage name="schoolName" />}
                  error={errors.schoolName && touched.schoolName}
                />
              </Grid>
              <div className="border-top padding-up-15 flex center-end margin-down-10">
                <div className=" margin-right-10">
                  <ActionButton
                    type="reset"
                    label={t("clear")}
                    actionButtonStyle="outline"
                    onClick={() => resetForm()}
                  ></ActionButton>
                </div>
                <ActionButton
                  label={t("submit")}
                  type="submit"
                  loading={loading}
                  disabled={dirty && isValid ? false : true}
                >
                  {t("submit")}
                </ActionButton>
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
}
